// 把java的时间戳格式 2019-12-16T07:38:23.000+0000 转成2019/12/16 07:38:23.000+0000
export function toNormalDate(stringDate){
  if(typeof stringDate == 'string'){
    return stringDate.replace(/-/g, '/').replace('T', ' ').toString();
  }else{
    return ''
  }
}

// 将时间戳转成固定时间  如 1573637240000  => 2019年11月13日 17:27
export function convertTime(timestamp) {
  if (timestamp === null) {
    return timestamp;
  }
  const t = new Date(timestamp);
  let year =1900 + t.getYear();
  let month = t.getMonth() + 1;
  let day = t.getDate();
  let hour = t.getHours();
  let minutes = t.getMinutes();
  day = day >= 10 ? day : "0" + day;
  hour = hour >= 10 ? hour : "0" + hour;
  minutes = minutes >= 10 ? minutes : "0" + minutes;
  return year + '年' + month + '月' + day + "日 " + hour +': '+ minutes;
}

// dateFtt('YYYY-mm-dd HH:MM:SS',1573637240000) => 2019-11-13 17:27:xx
export function dateFtt(fmt, dateString) {
  let date = new Date(dateString);
  let ret;
  let opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      }
  }
  return fmt;
}

// dateFtt2('YYYY-mm-dd HH:MM:SS',new Date()) => 2019-11-13 17:27:xx
export function dateFtt2(fmt, dateString) {
  let date = new Date(dateString);
  let ret;
  let opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      }
  }
  return fmt;
}

// 作用:将毫秒数处理为 YYYY-MM-DD hh:mm:ss 的日期格式(完善element中日期的bug,将00:00:00 补充为 23:59:59)
export function remedyTime (time, fmt = 'YYYY-MM-DD hh:mm:ss') {
  if (!time) return ''
  let date = new Date(time - 0)
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, date.getFullYear() + '').substr(4 - RegExp.$1.length)
  }
  let o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let key in o) {
    if (new RegExp(`(${key})`).test(fmt)) {
      let str = o[key] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}




